import { motion, AnimatePresence } from 'framer-motion';
import { useState } from 'react';
import './services.css';

const services = [
  {
    title: "Fullstack Development",
    description: "End-to-end digital solutions from frontend to cloud infrastructure.",
    icon: "🛠️",
    color: "#6366f1",
    features: [
      "Frontend: React, Vue, Tailwind",
      "Backend: Node.js, Firebase, PHP",
      "APIs & DB: REST, GraphQL, MongoDB, MySQL",
      "Deployment: Vercel, Firebase, AWS"
    ]
  },
  {
    title: "Blockchain Solutions",
    description: "Smart contracts, dApps, and Web3 integration services.",
    icon: "⛓️",
    color: "#10b981",
    features: [
      "Smart Contract Dev (Solidity, Vyper)",
      "dApps on Ethereum, Celo, Polygon",
      "Wallet integrations (MetaMask, Rainbow)",
      "NFTs, DeFi, DAOs, Tokenomics"
    ]
  },
  {
    title: "SEO & Marketing",
    description: "Data-driven strategies to dominate search rankings.",
    icon: "📊", 
    color: "#3b82f6",
    features: [
      "On-page SEO Optimization",
      "Content Strategy & Keyword Planning",
      "Google Ads & Analytics",
      "Email, SMS & Social Media Marketing"
    ]
  },
  {
    title: "Live Streaming",
    description: "Broadcast-grade live production for any platform.",
    icon: "🎬",
    color: "#ef4444",
    features: [
      "Multi-camera & 4K streaming setup",
      "RTMP, OBS, YouTube, Facebook Live",
      "Custom overlays, intros, branding",
      "Remote guest interviews & hybrid events"
    ]
  }
];

export default function Services() {
  const [activeService, setActiveService] = useState(null);

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const item = {
    hidden: { opacity: 0, y: 50 },
    show: { 
      opacity: 1, 
      y: 0,
      transition: { type: "spring", stiffness: 80, damping: 15 }
    }
  };

  return (
    <motion.section 
      id="services"
      className="services-section"
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-100px" }}
      variants={container}
    >
      <div className="section-header">
        <motion.h2 variants={item}>Specialized Services</motion.h2>
        <motion.p variants={item} className="section-subtitle">
          Tailored solutions for your digital transformation
        </motion.p>
      </div>

      <div className="services-container">
        {services.map((service, index) => (
          <motion.div 
            key={index}
            className="service-card"
            variants={item}
            whileHover={{ y: -10, transition: { duration: 0.2 } }}
            style={{ '--accent': service.color }}
          >
            <div className="card-icon">{service.icon}</div>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <div 
              className="card-cta"
              onClick={() => setActiveService(service)}
            >
              <span>Learn more →</span>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Modal */}
      <AnimatePresence>
        {activeService && (
          <motion.div 
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div 
              className="modal-content"
              initial={{ y: 100, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: 100, opacity: 0 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              <button className="modal-close" onClick={() => setActiveService(null)}>✕</button>
              <h2>{activeService.icon} {activeService.title}</h2>
              <p>{activeService.description}</p>
              <ul>
                {activeService.features.map((feature, i) => (
                  <li key={i}>✔️ {feature}</li>
                ))}
              </ul>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.section>
  );
}
